module.exports = __webpack_public_path__ + "img/11.363c0b67.jpg";